import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'
import { AgGridVue } from 'ag-grid-vue3'

export default defineNuxtPlugin((app) => {
   ModuleRegistry.registerModules([AllCommunityModule])
   app.vueApp.component('AgGridVue', AgGridVue)
})
